import React, { memo } from 'react';

import { array, arrayOf, bool, func, object, oneOfType, string } from 'prop-types';

import { CardType } from '@philips-emr/tws-components-api/lib/constants';
import { key, mobile } from '@philips-emr/tws-utils';

import { AvatarCard, NotFound } from '../..';
import { getMonthEventsGroupedByDay, getMonthGrid } from '../calendar-util';

import { MonthlyWeekRow } from '.';

function EventGroup({ events }) {
  const title = events[0].date.format('dddd');

  return (
    <div className="c-calendar-group">
      <div className="c-calendar-group__title">{title}</div>
      {events.map(event => {
        const eventCard = {
          date: event.date,
          img: event.img,
          status: event.status,
          subtitle: event.subtitle,
          title: event.title,
          type: CardType.FEATURED,
        };

        return (
          <div key={key('c-calendar__card')} className="c-calendar__card">
            <AvatarCard {...eventCard}/>
          </div>
        );
      })}
    </div>
  );
}

EventGroup.propTypes = {
  events: array,
};

const MonthlyDesktopCalendar = memo(function MonthlyDesktopCalendar(props) {
  const { canAddNew, date, events, onAddNew, onEventClick, rangeEnabled, ranges } = props;

  return (
    <React.Fragment>
      {getMonthGrid(date, events, ranges).map((week) => (
        <MonthlyWeekRow
          canAddNew={canAddNew}
          key={key('c-calendar-week-row')}
          onAddNew={onAddNew}
          onEventClick={onEventClick}
          rangeEnabled={rangeEnabled}
          week={week}
        />
      ))}
    </React.Fragment>
  );
});

MonthlyDesktopCalendar.propTypes = {
  canAddNew: bool,
  date: oneOfType([string, object]),
  events: array,
  onAddNew: func,
  onEventClick: func,
  rangeEnabled: bool,
  ranges: arrayOf(object),
};

function MonthlyMobileCalendar({ events, date }) {
  const groupedEvents = getMonthEventsGroupedByDay(events, date);

  if (!Array.isArray(groupedEvents) || groupedEvents.length === 0) {
    return (
      <NotFound showImage={false} />
    );
  }

  return groupedEvents.map((dayEvents) => {
    return (
      <EventGroup events={dayEvents} date={date} key={key('c-calendar-group')} />
    );
  });
}

MonthlyMobileCalendar.propTypes = {
  events: array,
  date: oneOfType([string, object]),
};

function MonthlyCalendar(props) {
  const { canAddNew, date, events, onAddNew, onEventClick, rangeEnabled, ranges } = props;

  if (mobile.isMobile()) {
    return <MonthlyMobileCalendar date={date} events={events} />;
  }

  return (
    <MonthlyDesktopCalendar
      canAddNew={canAddNew}
      date={date}
      events={events}
      onAddNew={onAddNew}
      onEventClick={onEventClick}
      rangeEnabled={rangeEnabled}
      ranges={ranges}
    />
  );
}

MonthlyCalendar.propTypes = {
  canAddNew: bool,
  date: oneOfType([string, object]),
  events: array,
  onAddNew: func,
  onEventClick: func,
  rangeEnabled: bool,
  ranges: arrayOf(object),
};

export default MonthlyCalendar;
